import { render, staticRenderFns } from "./BoqTnkcHouseInspection.vue?vue&type=template&id=48661fde&scoped=true"
import script from "./BoqTnkcHouseInspection.vue?vue&type=script&lang=js"
export * from "./BoqTnkcHouseInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48661fde",
  null
  
)

export default component.exports